var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{class:`position-fixed m-0 rounded-0 fixed-${_vm.position}`,style:(`z-index: ${_vm.zIndex};`),attrs:{"fade":true,"variant":_vm.alert.variant,"dismissible":_vm.dismissible},model:{value:(_vm.alert.show),callback:function ($$v) {_vm.$set(_vm.alert, "show", $$v)},expression:"alert.show"}},[_vm._v(" "+_vm._s(_vm.alert.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }